module.exports = __webpack_public_path__ + "img/BlendBuff-LoadFactorReduce.9c05933d.png";